var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1019_131276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.94727,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FDB62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1022 45.0774H38.3372C35.8772 45.0774 33.8822 43.0074 33.8822 40.4574C33.8822 39.8424 34.3922 39.3324 35.0072 39.3324C35.6222 39.3324 36.1322 39.8424 36.1322 40.4574C36.1322 41.7624 37.1222 42.8274 38.3372 42.8274H42.1022C43.0772 42.8274 43.8872 41.9574 43.8872 40.9074C43.8872 39.6024 43.4222 39.3474 42.6572 39.0774L36.6122 36.9474C35.4422 36.5424 33.8672 35.6724 33.8672 32.9874C33.8672 30.6774 35.6822 28.8174 37.9022 28.8174H41.6672C44.1272 28.8174 46.1222 30.8874 46.1222 33.4374C46.1222 34.0524 45.6122 34.5624 44.9972 34.5624C44.3822 34.5624 43.8722 34.0524 43.8722 33.4374C43.8722 32.1324 42.8822 31.0674 41.6672 31.0674H37.9022C36.9272 31.0674 36.1172 31.9374 36.1172 32.9874C36.1172 34.2924 36.5822 34.5474 37.3472 34.8174L43.3922 36.9474C44.5622 37.3524 46.1372 38.2224 46.1372 40.9074C46.1222 43.2024 44.3222 45.0774 42.1022 45.0774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 47.0723C39.385 47.0723 38.875 46.5623 38.875 45.9473V27.9473C38.875 27.3323 39.385 26.8223 40 26.8223C40.615 26.8223 41.125 27.3323 41.125 27.9473V45.9473C41.125 46.5623 40.615 47.0723 40 47.0723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 53.0723C31.105 53.0723 23.875 45.8423 23.875 36.9473C23.875 28.0523 31.105 20.8223 40 20.8223C48.895 20.8223 56.125 28.0523 56.125 36.9473C56.125 45.8423 48.895 53.0723 40 53.0723ZM40 23.0723C32.35 23.0723 26.125 29.2973 26.125 36.9473C26.125 44.5973 32.35 50.8223 40 50.8223C47.65 50.8223 53.875 44.5973 53.875 36.9473C53.875 29.2973 47.65 23.0723 40 23.0723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1019_131276",
    x: 0,
    y: 0.947266,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1019_131276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1019_131276",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.fd643f94e0e17d6d307322c65b0a9224.svg";
export { ForwardRef as ReactComponent };